/**
 * Notifies any mounted page that a build was uploaded through the global
 * drag-and-drop flow, which lives outside the project page's own component
 * tree and so has no direct reference to that page's refetch functions.
 */
export const UPLOAD_COMPLETE_EVENT = "gs-upload-complete";

export interface UploadCompleteDetail {
  projectId: string | number;
  type: "app" | "testBuild";
}

export const emitUploadComplete = (detail: UploadCompleteDetail): void => {
  window.dispatchEvent(
    new CustomEvent<UploadCompleteDetail>(UPLOAD_COMPLETE_EVENT, { detail })
  );
};

/** Returns an unsubscribe function, ready to hand straight to a useEffect cleanup. */
export const onUploadComplete = (
  handler: (detail: UploadCompleteDetail) => void
): (() => void) => {
  const listener = (e: Event) => {
    handler((e as CustomEvent<UploadCompleteDetail>).detail);
  };
  window.addEventListener(UPLOAD_COMPLETE_EVENT, listener);
  return () => window.removeEventListener(UPLOAD_COMPLETE_EVENT, listener);
};
